import { recordError } from '@util/Errors';
import firebase from 'firebase/compat/app';
import 'firebase/compat/remote-config';
import { Experiment, VariantOf, VariantsConfig } from './Experiment';

const remoteConfig = firebase.remoteConfig;

/** An experiment configured using RemoteConfig. */
export class RemoteConfigExperiment<Variants extends VariantsConfig> extends Experiment<Variants> {
  /** The experiment's key used in RemoteConfig. E.g. `ExpMoneyMaker`. */
  public get configKey(): string {
    return `Exp${this.name}`;
  }

  /** Get the variant from RemoteConfig if ready and available. */
  protected getVariantFromSource(): VariantOf<Variants> | undefined {
    let variant: VariantOf<Variants> | undefined = undefined;

    const configValueDetails = remoteConfig().getValue(this.configKey);
    const configValue = configValueDetails.asString();

    // Static source indicates that `remoteConfig.setDefaults()` has yet to complete and would result
    // in an empty string.
    if (configValueDetails.getSource() === 'remote') {
      if (this.allVariants.includes(configValue as VariantOf<Variants>)) {
        variant = configValue as VariantOf<Variants>;
      } else {
        recordError(
          new Error(`Unknown RemoteConfig experiment variant '${configValue}' in ${this.name}`)
        );
      }
    }

    return variant;
  }
}
